module.exports = __webpack_public_path__ + "img/logo_lq_white_min_v2024.d0261baf.png";